import classNames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type Props = {
    onClick: () => void;
    zoomLinkValue: string;
    className?: string;
};

const ZoomLink = ({ onClick, zoomLinkValue, className }: Props) => {
    const { t } = useGranite();

    return (
        <div
            className={classNames(className, "imageViewer__zoom-link-holder")}
            onClick={onClick}
        >
            <a href={zoomLinkValue} className="btn-link">
                <i className="las la-search-plus la-lg" />
                <span className="ml-1">
                    {t("productDetail.imageViewer.link.zoom")}
                </span>
            </a>
        </div>
    );
};

export { ZoomLink };
